module.exports = __webpack_public_path__ + "img/COMAIR BRANDED B KULULA.3cfd3c5f.png";